import { render, staticRenderFns } from "./Manualtopup.vue?vue&type=template&id=615794f7&scoped=true"
import script from "./Manualtopup.vue?vue&type=script&lang=js"
export * from "./Manualtopup.vue?vue&type=script&lang=js"
import style0 from "./Manualtopup.vue?vue&type=style&index=0&id=615794f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615794f7",
  null
  
)

export default component.exports